export default __webpack_public_path__ + "1152411b80a3cbecec93d32d90e54747.png";